import React, { useState, useEffect } from 'react';
// @ts-ignore - TS 4.9.5 can't resolve all exports from lucide-react's large barrel d.ts
import Download from 'lucide-react/dist/esm/icons/download';
// @ts-ignore
import X from 'lucide-react/dist/esm/icons/x';
// @ts-ignore
import Smartphone from 'lucide-react/dist/esm/icons/smartphone';
// @ts-ignore
import Wifi from 'lucide-react/dist/esm/icons/wifi';
// @ts-ignore
import WifiOff from 'lucide-react/dist/esm/icons/wifi-off';
import { usePWAInstall } from '../../hooks/usePWAInstall';

const PWAInstallPrompt: React.FC = () => {
  const { showPrompt, canInstall, isInstalled, install, dismiss } = usePWAInstall();
  const [installing, setInstalling] = useState(false);
  const [showIOSInstructions, setShowIOSInstructions] = useState(false);

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const isStandalone =
    window.matchMedia('(display-mode: standalone)').matches ||
    (window.navigator as any).standalone === true;

  // On iOS, show manual instructions since beforeinstallprompt is not supported
  useEffect(() => {
    if (isIOS && !isStandalone && !isInstalled) {
      const dismissed = localStorage.getItem('confereai_pwa_install_dismissed');
      if (dismissed) {
        const dismissedTime = new Date(dismissed).getTime();
        if (Date.now() - dismissedTime < 24 * 60 * 60 * 1000) return;
      }
      setShowIOSInstructions(true);
    }
  }, [isIOS, isStandalone, isInstalled]);

  const handleInstall = async () => {
    setInstalling(true);
    try {
      await install();
    } finally {
      setInstalling(false);
    }
  };

  const handleDismissIOS = () => {
    setShowIOSInstructions(false);
    localStorage.setItem('confereai_pwa_install_dismissed', new Date().toISOString());
  };

  if (isInstalled || isStandalone) return null;

  // iOS instructions
  if (showIOSInstructions) {
    return (
      <div className="fixed inset-0 bg-black/50 z-50 flex items-end sm:items-center justify-center p-4 animate-fadeIn">
        <div className="bg-white rounded-t-2xl sm:rounded-2xl w-full max-w-md shadow-2xl animate-slideUp">
          <div className="p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center">
                  <Smartphone className="w-6 h-6 text-green-600" />
                </div>
                <div>
                  <h3 className="font-bold text-gray-900">Instalar Confere Ai</h3>
                  <p className="text-xs text-gray-500">Coletor de Conferencia</p>
                </div>
              </div>
              <button
                onClick={handleDismissIOS}
                className="p-2 rounded-lg hover:bg-gray-100 text-gray-400"
                aria-label="Fechar"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            <div className="bg-gray-50 rounded-xl p-4 space-y-3">
              <p className="text-sm font-medium text-gray-700">Para instalar no iPhone/iPad:</p>
              <div className="flex items-start gap-3">
                <span className="w-6 h-6 bg-green-600 text-white rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0">1</span>
                <p className="text-sm text-gray-600">
                  Toque no botao <strong>Compartilhar</strong> (icone de quadrado com seta para cima) na barra inferior do Safari
                </p>
              </div>
              <div className="flex items-start gap-3">
                <span className="w-6 h-6 bg-green-600 text-white rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0">2</span>
                <p className="text-sm text-gray-600">
                  Role para baixo e toque em <strong>"Adicionar a Tela de Inicio"</strong>
                </p>
              </div>
              <div className="flex items-start gap-3">
                <span className="w-6 h-6 bg-green-600 text-white rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0">3</span>
                <p className="text-sm text-gray-600">
                  Toque em <strong>"Adicionar"</strong> para confirmar
                </p>
              </div>
            </div>

            <div className="mt-4 flex items-center gap-2 text-xs text-gray-400">
              <Wifi className="w-3 h-3" />
              <span>Funciona offline apos a instalacao</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Native install prompt (Android/Chrome)
  if (!showPrompt || !canInstall) return null;

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-end sm:items-center justify-center p-4 animate-fadeIn">
      <div className="bg-white rounded-t-2xl sm:rounded-2xl w-full max-w-md shadow-2xl animate-slideUp">
        <div className="p-6">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center">
                <Download className="w-6 h-6 text-green-600" />
              </div>
              <div>
                <h3 className="font-bold text-gray-900">Instalar Confere Ai</h3>
                <p className="text-xs text-gray-500">Coletor de Conferencia</p>
              </div>
            </div>
            <button
              onClick={dismiss}
              className="p-2 rounded-lg hover:bg-gray-100 text-gray-400"
              aria-label="Fechar"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          <div className="space-y-3 mb-6">
            <div className="flex items-center gap-3 text-sm text-gray-600">
              <Smartphone className="w-5 h-5 text-green-500 flex-shrink-0" />
              <span>Acesso rapido direto da tela inicial</span>
            </div>
            <div className="flex items-center gap-3 text-sm text-gray-600">
              <WifiOff className="w-5 h-5 text-green-500 flex-shrink-0" />
              <span>Funciona offline - ideal para areas remotas do galpao</span>
            </div>
            <div className="flex items-center gap-3 text-sm text-gray-600">
              <Wifi className="w-5 h-5 text-green-500 flex-shrink-0" />
              <span>Sincroniza automaticamente quando reconectar</span>
            </div>
          </div>

          <div className="flex gap-3">
            <button
              onClick={dismiss}
              className="flex-1 px-4 py-3 border border-gray-300 text-gray-700 rounded-xl font-medium hover:bg-gray-50 transition"
            >
              Agora nao
            </button>
            <button
              onClick={handleInstall}
              disabled={installing}
              className="flex-1 px-4 py-3 bg-green-600 text-white rounded-xl font-semibold hover:bg-green-700 transition disabled:opacity-50 flex items-center justify-center gap-2"
            >
              {installing ? (
                <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
              ) : (
                <>
                  <Download className="w-5 h-5" />
                  Instalar
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PWAInstallPrompt;
